import React from 'react';
import { 
  Card, 
  CardContent, 
  Typography, 
  Grid, 
  Button, 
  Box 
} from '@mui/material';
import {
  Headphones as HeadphonesIcon,
  AccessTime as AccessTimeIcon,
  PlayArrow as PlayArrowIcon
} from '@mui/icons-material';

interface AudioTechnique {
  title: string;
  duration: string;
  type: string;
}

interface AudioTechniquesBlockProps {
  techniques: AudioTechnique[];
  onStartTechnique?: (technique: AudioTechnique) => void;
}

const AudioTechniquesBlock: React.FC<AudioTechniquesBlockProps> = ({ 
  techniques,
  onStartTechnique 
}) => {
  return (
    <Card sx={{ mb: 4 }}>
      <CardContent>
        <Typography variant="h5" gutterBottom sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
          <HeadphonesIcon color="primary" />
          Быстрые техники
        </Typography>
        <Grid container spacing={2}>
          {techniques.map((technique, index) => (
            <Grid item xs={12} sm={6} md={4} key={index}>
              <Card variant="outlined" sx={{ height: '100%' }}>
                <CardContent>
                  <Typography variant="h6" gutterBottom>
                    {technique.title}
                  </Typography>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                    <AccessTimeIcon fontSize="small" color="action" />
                    <Typography variant="body2" color="text.secondary">
                      {technique.duration}
                    </Typography>
                  </Box>
                  <Button
                    variant="contained"
                    startIcon={<PlayArrowIcon />}
                    fullWidth
                    onClick={() => onStartTechnique?.(technique)}
                  >
                    Начать
                  </Button>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </CardContent>
    </Card>
  );
};

export default AudioTechniquesBlock; 